import { CspBaseConfig } from '../model/CspBaseConfig';
import { CspPodConfig, CspPodConfigs } from '../model/CspPodConfigs';

type CspPodConfigsWrapper = {
  podConfigs: CspPodConfigs;
  baseConfig: CspBaseConfig;
};

const singleton: CspPodConfigsWrapper = {
  podConfigs: {},
  baseConfig: CspBaseConfig.empty(),
};

const setCspBaseConfig = (cspBaseConfig: CspBaseConfig): void => {
  singleton.baseConfig = cspBaseConfig;
};

const getCspBaseConfig = (): CspBaseConfig => singleton.baseConfig;

const setCspPodConfigs = (podConfigs: CspPodConfigs): void => {
  singleton.podConfigs = podConfigs;
};

const getCspPodConfigs = (): CspPodConfigs => singleton.podConfigs;

const getCspPodConfig = (podName: keyof CspPodConfigs): CspPodConfig => {
  const podConfig = singleton.podConfigs[podName];
  if (!podConfig) {
    throw new Error(`The pod config for ${podName} is not set`);
  }
  return podConfig;
};

export const CspConfigService = {
  getCspPodConfig,
  getCspPodConfigs,
  setCspPodConfigs,
  getCspBaseConfig,
  setCspBaseConfig,
};
